export enum IconType {
  Restaurant,
  RestaurantMenu,
  MenuBook,
  LocalGroceryStore,
}